import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[appInlineConfirmationTrigger]',
  exportAs: "appInlineConfirmationTrigger",
  standalone: true
})
export class InlineConfirmationTriggerDirective {
  public elementRef: ElementRef<HTMLElement> = inject<ElementRef<HTMLElement>>(ElementRef<HTMLElement>);
}
